import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { FaImage, FaCamera } from 'react-icons/fa';


const previewContainerStyle = {
  width: '365px',
  minHeight: '557px',
  maxHeight: '667px',
  margin: '10px auto',
  border: '1px solid #ccc',
  borderRadius: '20px',
  overflow: 'hidden',
  boxShadow: '0 0 10px rgba(0,0,0,0.2)',
  backgroundColor: '#f8f9fa',
  display: 'flex',
  flexDirection: 'column',
};

const headerStyle = {
  backgroundColor: '#fff',
  padding: '15px',
  display: 'flex',
  alignItems: 'center',
};

const backButtonStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '18px',
  color: 'rgb(14,57,114)',
};

const actionContainerStyle = {
  backgroundColor: '#fff',
  margin: '20px',
  padding: '20px',
  borderRadius: '4px',
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
};

const submitTextStyle = {
  fontSize: '20px',
  fontWeight: 'bold',
  color: 'orange',
};

export default function ImagePickerWeb() {
  const navigate = useNavigate();
  const [profilePic, setProfilePic] = useState(null);
  const dist = sessionStorage.getItem('dist');

  const onFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfilePic(file);
    }
  };

  useEffect(() => {
    if (profilePic) {
      handleSubmit();
    }
  }, [profilePic]);

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('file', profilePic);
    formData.append('dist', dist || '320E');

    try {
      const res = await axios.post(
        'https://lionsdirectoryapi.emedha.in/uploadGallery-320e',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (res.status === 200 || res.status === 201) {
        alert('Your data has been submitted successfully!');
        navigate('/home');
      } else {
        alert(`Upload failed with status ${res.status}`);
      }
    } catch (err) {
      console.error(err);
      alert('An error occurred during the image upload.');
    }
  };

  return (
    <div style={previewContainerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <button style={backButtonStyle} onClick={() => navigate('/home')}>
          <ArrowLeftOutlined /> Back
        </button>
      </div>

      {/* Actions */}
      <div style={actionContainerStyle}>
        <label htmlFor="file-input" style={{ cursor: 'pointer', textAlign: 'center', color: 'orange' }}>
          <div>
       <FaImage size={40} color="orange" />

          </div>
          <div>Gallery</div>
        </label>

        <label htmlFor="camera-input" style={{ cursor: 'pointer', textAlign: 'center', color: 'orange' }}>
          <div>
<FaCamera size={40} color="orange" />

          </div>
          <div>Camera</div>
        </label>
      </div>

      <div style={actionContainerStyle}>
        <span style={submitTextStyle}>Upload Image</span>
      </div>

      {/* Hidden file inputs */}
      <input
        id="file-input"
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={onFileChange}
      />

      <input
        id="camera-input"
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: 'none' }}
        onChange={onFileChange}
      />
    </div>
  );
}
